import Axios from "axios";
export default({
    state: {
      users: []
    },
    mutations: {
      SET_USERS(state, payload){
        state.users = payload;
      }
    },
    actions: {  
      getProducts() {
        return Axios.get(process.env.VUE_APP_API_URL+"/product",
        {
          headers: { "Content-type": "application/json" }
        })
        .then((res) => {
            return res;
        })
      }
    },
    getters: {},
  });